import axios from 'axios'
import {
  SaleApproversRequest,
  TCreateUserRequest,
  TEditUserRequest,
} from '../../../coreGlobal/models/user'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const USER_URL = `${API_URL}/users`
const GROUP_URL = `${API_URL}/groups/all`
const FRANCHISE_URL = `${API_URL}/franchises`
const ADMIN_USER_URL = `${API_URL}/admin/users`
const ADMIN_GROUP_URL = `${API_URL}/admin/groups/all`
const ADMIN_FRANCHISE_URL = `${API_URL}/admin/franchises`
const VALIDATION_URL = `${API_URL}`

const getUsersById = (userId: string | number, isAdmin = false) => {
  const url = isAdmin
    ? `${ADMIN_USER_URL}/${userId}?include=roles,franchises`
    : `${USER_URL}/${userId}?include=person.physicalPerson,roles,franchises`
  return axios
    .get(url)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getUsers = () => {
  return axios
    .get(`${USER_URL}/all`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getSaleApprovers = (id: string | number | undefined) => {
  return axios
    .get(`${FRANCHISE_URL}/${id}/sale-approvers`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const updateSaleApprovers = (id: string | number | undefined, data: SaleApproversRequest) => {
  return axios
    .put(`${FRANCHISE_URL}/${id}/sale-approvers`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getGroups = (isAdmin = false): Promise<any | undefined> => {
  return axios
    .get(isAdmin ? ADMIN_GROUP_URL : GROUP_URL)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getFranchises = (isAdmin = false): Promise<any | undefined> => {
  return axios
    .get(`${isAdmin ? ADMIN_FRANCHISE_URL : FRANCHISE_URL}/all`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const createUser = (request: TCreateUserRequest, isAdmin = false) => {
  return axios
    .post(isAdmin ? ADMIN_USER_URL : USER_URL, request)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const updateUser = (userId: string | number, data: TEditUserRequest, isAdmin = false) => {
  return axios
    .put(`${isAdmin ? ADMIN_USER_URL : USER_URL}/${userId}`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

export const validatePersonPhone = (number: string) => {
  return axios
    .get(`${VALIDATION_URL}/validation/phone/${number}`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const impersonateUser = (userId: string | number) => {
  return axios.post(`${ADMIN_USER_URL}/${userId}/impersonate`).then((response: any) => response.data)
}

export {
  impersonateUser,
  getUsersById,
  getGroups,
  getFranchises,
  createUser,
  updateUser,
  getUsers,
  getSaleApprovers,
  updateSaleApprovers,
}
